import React, { Fragment } from "react"
import { Helmet } from "react-helmet"

const SocialBanner = () => (
    <Fragment>
        <Helmet>
            <script src="https://kit.fontawesome.com/3736921366.js" crossorigin="anonymous"></script>
        </Helmet>
        <div className="container-fluid color-three">
            <div className="row align-items-center p-4">
                <div className="col-lg"></div>
                <div className="col text-right mr-4">
                    <a href="https://www.facebook.com/thrivingmadly/"><i className="fab fa-facebook-square social-banner-icon" aria-label="Facebook"></i><span className="sr-only">Facebook</span></a>
                    <a href="https://www.instagram.com/thrivingmadly/"><i className="fab fa-instagram social-banner-icon" aria-label="Instagram"></i><span className="sr-only">Instagram</span></a>
                    <a href="https://www.patreon.com/user?u=15525051"><i className="fab fa-patreon social-banner-icon" aria-label="Patreon"></i><span className="sr-only">Patreon</span></a>
                </div>
                <div className="col">
                    <p className="med-text-color-bg m-0">Keep up with what we're up to.</p>
                </div>
                <div className="col-lg"></div>
            </div>
        </div>
    </Fragment>
)

export default SocialBanner